import * as pbi from '../public/index.component'
import { AdminService } from './admin.service';
import { AuthorizePPService } from '../authorizePP/authorizePP.service';
declare var jquery: any;
declare var $: any;
@pbi.Component({
    selector: 'admin',
    templateUrl: './admin.component.html'

})
export class AdminComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    showLoad: boolean = true;
    backLoad: string = "#352e2e87";
    loaded: boolean = false;
   
    constructor(
        private adminService: AdminService
    ) { }

    ngOnInit() {
        var this_sav = this;

        this_sav.pb_func.loadCSS([
            "assets/global/plugins/bootstrap-daterangepicker/daterangepicker.min.css",
            "assets/global/plugins/morris/morris.css",
            "assets/global/plugins/fullcalendar/fullcalendar.min.css",
            "assets/global/plugins/jqvmap/jqvmap/jqvmap.css",
            "assets/global/plugins/datatables/datatables.min.css",
            "assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.css",
            "assets/global/plugins/bootstrap-datepicker/css/bootstrap-datepicker3.min.css",
            "assets/global/css/components.min.css",
            "assets/global/css/plugins.min.css",
    
            "assets/layouts/layout/css/layout.min.css",
            "assets/layouts/layout/css/themes/darkblue.min.css",
            "assets/layouts/layout/css/custom.min.css",
            
            "assets/global/plugins/jstree/dist/themes/default/style.min.css",
            "assets/global/plugins/select2/css/select2.min.css",
            "assets/global/plugins/select2/css/select2-bootstrap.min.css",
            "assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.css",
            "assets/global/plugins/jquery-nestable/jquery.nestable.css",
            "assets/global/plugins/bootstrap-summernote/summernote.css",
            
            "assets/public.css",
        ],"admin",function(){
            this_sav.adminService.change.subscribe(result => {
                this_sav.showLoad = result.status;
                this_sav.backLoad = result.backLoad;
            });
        });

        this_sav.pb_func.loadScript([
            'assets/global/plugins/js.cookie.min.js',
            'assets/global/plugins/bootstrap-hover-dropdown/bootstrap-hover-dropdown.min.js',
            'assets/global/plugins/jquery-slimscroll/jquery.slimscroll.min.js',
            'assets/global/plugins/jquery.blockui.min.js',
            'assets/global/plugins/uniform/jquery.uniform.min.js',
            'assets/global/plugins/bootstrap-switch/js/bootstrap-switch.min.js',
            'assets/global/plugins/moment.min.js',
            'assets/global/plugins/bootstrap-daterangepicker/daterangepicker.min.js',
            'assets/global/plugins/bootstrap-datepicker/js/bootstrap-datepicker.min.js',
            'assets/global/scripts/app.min.js',
            'assets/layouts/layout/scripts/layout.js',
            'assets/layouts/layout/scripts/demo.min.js',
            'assets/layouts/global/scripts/quick-sidebar.min.js'
        ],"admin",function(){
            this_sav.loaded = true;
        });
    };
}


// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts